import { useRef } from "react";
import PropTypes from "prop-types";

const Mentors = ({ mentorImages: providedImages }) => {
  const sliderRef = useRef(null);

  // Use provided images array or default to homepage images
  const mentorImages = providedImages || Array.from(
    { length: 15 },
    (_, i) => `/home/osmentor${i + 1}.webp`
  );

  const scroll = (dir) => {
    if (!sliderRef.current) return;
    const isMobile = window.innerWidth < 768;
    const scrollAmount = isMobile ? 280 : 320; // Card width + gap
    sliderRef.current.scrollBy({
      left: dir === "next" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div
      data-section-theme="light "
      className="w-full  font-fira-sans"
      style={{
        borderTop: "1px solid #08090A33",
        borderBottom: "1px solid #08090A33",
      }}
    >
      {/* Container with left and right borders */}
      <div
        className="gutter-x"
        style={{
          borderLeft: "1px solid #08090A33",
          borderRight: "1px solid #08090A33",
        }}
      >
        {/* Content with 60px left padding */}
        <div className="px-4 md:px-0 md:pl-[60px] md:pr-[60px] pt-10">
          {/* Heading Section */}
          <div className="mb-12">
            <p className="text-black text-[16px] tracking-[1.75px] leading-[160%] font-normal uppercase mb-4">
              EXPERT-LED LEARNING
            </p>
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <h2 className="text-black text-[30px] md:text-[38px] leading-[120%] font-medium">
                Learn from AI Leaders, Not Influencers
              </h2>

              {/* Navigation Buttons - Desktop */}
              <div className="hidden md:flex gap-3">
                <button
                  onClick={() => scroll("prev")}
                  aria-label="Scroll mentors left"
                  className="w-10 h-10 border border-black/40 rounded flex items-center justify-center"
                >
                  ←
                </button>
                <button
                  onClick={() => scroll("next")}
                  aria-label="Scroll mentors right"
                  className="w-10 h-10 bg-black text-white rounded flex items-center justify-center"
                >
                  →
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Slider - Outside padded content to allow touching borders */}
        <div className="overflow-hidden pb-16">
          <div className="-mx-4 md:mx-0">
            <div
              ref={sliderRef}
              className="flex gap-4 md:gap-6 overflow-x-auto scrollbar-hide pl-4 pr-4 md:pl-[60px] md:pr-0"
              style={{ WebkitOverflowScrolling: "touch" }}
            >
              {mentorImages.map((image, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-[280px] md:w-[300px]"
                >
                  <img
                    src={image}
                    alt={`Mentor ${index + 1}`}
                    width="300"
                    height="420"
                    className="w-full h-auto object-cover"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Mentors.propTypes = {
  mentorImages: PropTypes.arrayOf(PropTypes.string),
};

export default Mentors;
